import { Application } from "@hotwired/stimulus"

import { definitionsFromContext } from "@stimulus/webpack-helpers"

const application = Application.start()
const app_context = require.context("./app", true, /\.js$/)
application.load(definitionsFromContext(app_context))
const lib_context = require.context("./lib", true, /\.js$/)
application.load(definitionsFromContext(lib_context))
window.Stimulus = application

application.debug = false

export { application }
